import React, {useContext} from 'react'
import {useRouter} from 'next/router'
import PropTypes from 'prop-types'
import {USBGrid, USBColumn} from '@usb-shield/react-grid'
import PageTitle from '../../atoms/PageTitle/PageTitle'
import {
  getPageTitle,
  isLoginEnabled
} from '../../../utils/Utility'
import {AuthContext} from '../../../context/AuthContext'


const Content = ({ children: renderedPageContent, pageTitleClasses=null, paddingColumnCount = 2, contentAreaClassName = "contentArea", contentAreaColumnClassName = "ContentColumn" }) => {
  const router = useRouter()
  const { isAuthenticated } = useContext(AuthContext)

  const isAuthenticatedFn = () => {
    return Boolean(isAuthenticated)
  }


  const getPageHeading = () => {
    let heading = 'Login'
    if (isAuthenticatedFn()) heading = router.route ? getPageTitle(router.route) : 'Login'
    // if internal user we don't show login page
    if (!isLoginEnabled() && (heading === 'Login' || heading === 'Home')) heading = ''
    return heading
  }
  const isFooterLink = () => {
    //const footerLinks = ['Help', 'Contact Us', 'Privacy & Security']
    const footerLinks = ['Help', 'Privacy & Security']
    return footerLinks.find(o => o === getPageTitle(router.route))
  }
  const getTitle = () => {
    const heading = getPageHeading()
    return isFooterLink() || heading === 'Login' ? '' : heading
  }

  const isPublicPage = () => {
    const pageTitle = getPageTitle(router.route)
    return pageTitle === 'Login' || pageTitle === 'Help' || pageTitle === 'Privacy & Security'
  }

  const shouldRenderContent = () => {
    return isAuthenticatedFn() || isPublicPage()
  }

  const canRenderContent = typeof window !== 'undefined' && shouldRenderContent()


  return (
    <>
      {/* Page Title  */}
      <USBGrid addClasses={`white-frame pageTitle ${pageTitleClasses}`}>
        {(paddingColumnCount > 0) && <USBColumn largeSpan={paddingColumnCount} />}
        <USBColumn largeSpan={16 - 2 * paddingColumnCount} addClasses={!paddingColumnCount ? 'left' : "middle"}>
          {getTitle() && <PageTitle headerText={getTitle()} />}
        </USBColumn>
        {(paddingColumnCount > 0) && <USBColumn largeSpan={paddingColumnCount} />}
      </USBGrid>
      {/* Main Content Area  */}
      <section className={contentAreaClassName}>
        <USBGrid>
          {(paddingColumnCount > 0) && <USBColumn largeSpan={paddingColumnCount} />}
          <USBColumn largeSpan={16 - 2 * paddingColumnCount} addClasses={contentAreaColumnClassName}>
            {canRenderContent ? renderedPageContent : null}
          </USBColumn>
          {(paddingColumnCount > 0) && <USBColumn largeSpan={paddingColumnCount} />}
        </USBGrid>
      </section>
    </>
  )
}

Content.propTypes = {
  children: PropTypes.node.isRequired,
  pageTitleClasses: PropTypes.string,
  paddingColumnCount: PropTypes.number,
  contentAreaClassName: PropTypes.string,
  contentAreaColumnClassName: PropTypes.string
}

Content.defaultProps = {
  pageTitleClasses: null,
  paddingColumnCount: 2,
  contentAreaClassName: "contentArea",
  contentAreaColumnClassName: "ContentColumn"
}

export default Content